import { getDisabledFilterFamilies } from 'customer-data-filters-ui/utils/addingCondition';
import { getExactKeyPath } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { useCallback, useContext, useMemo } from 'react';
import { useEditorActions } from '../hooks/useEditorActions';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
export const useFilterFamilySelect = () => {
  const {
    selectFilterFamily,
    selectFilterFamilyGroup
  } = useEditorActions();
  const {
    draftCondition,
    internalDraftValue
  } = useContext(SegmentationFiltersInstanceContext);
  const parentFilterGroup = useMemo(() => {
    if (draftCondition !== null && draftCondition !== void 0 && draftCondition.conditionPath) {
      return getExactKeyPath(draftCondition === null || draftCondition === void 0 ? void 0 : draftCondition.conditionPath, internalDraftValue);
    }
    return null;
  }, [draftCondition === null || draftCondition === void 0 ? void 0 : draftCondition.conditionPath, internalDraftValue]);
  const disabledFilterFamilies = useMemo(() => getDisabledFilterFamilies(parentFilterGroup), [parentFilterGroup]);
  const onFilterFamilySelect = useCallback(async option => {
    const newFilterFamily = option.value;
    if (option.isCategoriesGroup) {
      selectFilterFamilyGroup(newFilterFamily);
    } else {
      await selectFilterFamily(newFilterFamily, option.isAssociation);
    }
  }, [selectFilterFamily, selectFilterFamilyGroup]);
  return {
    disabledFilterFamilies,
    onFilterFamilySelect
  };
};